import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect, withRouter } from "react-router-dom";

import axios from "axios";
import Navbar from '../../Navbar';
import moment from "moment";

class CRPage extends Component {
    constructor(props) {
        super(props);

        //Allows use of state and this in the handlechange function
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            vehicle_info: {
                required_parts: {
                  exterior: ['front', 'passengers', 'drivers', 'rear'],
                  interior: ['Dashboard Display', 'Trunk Interior']
                },
                damage_options: {
                    exterior: ['Scuff', 'Scratch', 'Chip', 'Dent', 'Residue', 'Miscellaneous'],
                    interior: ['Crack', 'Scratch', 'Broken Piece', 'Missing Piece', 'Not Working', 'Miscellaneous'],
                },
                accessory_options: ['Cargo Cover', 'S/D Card', 'Floor Mats', 'Cigarette Lighter', 'Charging Cable', 'Insurance', 'Vehicle Registration', 'Accessory Key']
              },
        };

        this.fetchReport();
    }

    componentDidMount() {
        document.title = "Condition Report Tests - FleetXPress";
    }

    fetchReport() {
        let self = this;

        axios.post('/ajax/cr/report', {
            cr_id: '626' 
        })
        .then(function(response) {
            let exterior_damages_info = self.fetchDamageInfo(response?.data.exterior_damages, response?.data.report.exterior_damages);
            let interior_damages_info = self.fetchDamageInfo(response?.data.interior_damages, response?.data.report.interior_damages);
            let accessory_checkbox_info = self.fetchCheckboxInfo(response?.data.accessories, response?.data.report.accessories);

            self.setState(prevState => ({
              ...prevState,
              report: response?.data.report,
              previous_reports: response?.data.previous_reports,
              exterior_damages: response?.data.exterior_damages,
              interior_damages: response?.data.interior_damages,
              accessories: response?.data.accessories,
              exterior_damages_info: exterior_damages_info,
              interior_damages_info: interior_damages_info,
              accessory_checkbox_info: accessory_checkbox_info,
            }));
        })
        .catch(function(error) {
            // console.log(error)
        })
    }

    dashboard() {
        axios.post('/ajax/cr', {
            beginning_date: '2019-11-09',
            ending_date: '2019-11-15'
        })
        .then(function(response) {
            // console.log(response?.data)
        })
        .catch(function(error) {
            // console.log(error)
        })
    }

    createCR() {
        axios.post('/ajax/cr/create', {
            v_id: '3333' 
        })
        .then(function(response) {
            // console.log(response?.data)
        })
        .catch(function(error) {
            // console.log(error)
        })

    }

    storeCRNoExtra() {
        axios.post('/ajax/cr/store', {
            condition_type: 0,
            v_id: 3333,
            reported_by: 'Abbass',
            report_date: '2020-01-07',
            num_keys: 2,
            driver_signature: 'LINK',
            mileage: 1000,
            fuel: 8,
            exterior: {
                required_images: [
                    {
                        name: 'front',
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'
                    },
                    {
                        name: 'rear',
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'
                    }
                ],
            }
        })
        .then(function(response) {
            // console.log(response?.data)
        })
        .catch(function(error) {
            // console.log(error)
        })
    }

    storeCRExtraDetails() {
        axios.post('/ajax/cr/store', {
            condition_type: 0,
            v_id: 3333,
            reported_by: 'Abbass',
            report_date: '2020-01-07',
            num_keys: 2,
            driver_signature: 'LINK',
            mileage: 1000,
            fuel: 8,
            driver_details: {
                'drivers_name': 'Abbass',
                'driver_license_month': '04',
                'driver_license_year': '2014',
                'driver_last_digits': '8141'
            },
            bill_details: {
                'bill_company': 'Generic Company',
                'bill_images': [{photo: 'Photo1', thumbnail: 'Thumbnail1'}, {photo: 'Photo2', thumbnail: 'thumbnail2'}]
            },
            vla_details: {
                'vla_type': 0,
                'vla_terms': true,
                'vla_signature': 'SIGNATURE',
                'vla_signed_by': 'Abbass' 
            }
        })
        .then(function(response) {
            // console.log(response?.data)
        })
        .catch(function(error) {
            // console.log(error)
        })
    }
    
    storeEverything() {
        axios.post('/ajax/cr/store', {
            condition_type: 0,
            v_id: 3333,
            reported_by: 'Abbass',
            report_date: '2020-01-07',
            num_keys: 2,
            driver_signature: 'LINK',
            mileage: 1000,
            fuel: 8,
            driver_details: {
                'drivers_name': 'Abbass',
                'driver_license_month': '04',
                'driver_license_year': '2014',
                'driver_last_digits': '8141'
            },
            bill_details: {
                'bill_company': 'Generic Company',
                'bill_images': [{photo: 'Photo1', thumbnail: 'Thumbnail1'}, {photo: 'Photo2', thumbnail: 'thumbnail2'}]
            },
            vla_details: {
                'vla_type': 0,
                'vla_terms': true,
                'vla_signature': 'SIGNATURE',
                'vla_signed_by': 'Abbass' 
            },
            exterior: {
                required_images: [
                    {
                        name: 'front',
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'
                    },
                    {
                        name: 'passenger',
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                    },
                    {
                        name: 'drivers',
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                    },
                    {
                        name: 'rear',
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                    },
                ],
                damaged_parts: [
                        {
                            name: "Driver's Side Front Wheel",
                            notes: "Light scuff, damaged heavily",
                            images: [
                                {
                                    photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                                    thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                                }, 
                                {
                                    photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                                    thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                                },
                                {
                                    photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                                    thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                                },
                            ],
                            damages: ['Scratch', 'Paint Chip']
                        }
                ]
            },
            interior: {
                required_images: [
                    {
                        name: 'dashboard',
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'
                    },
                    {
                        name: 'trunk',
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                    },
                ],
                damaged_parts: [
                        {
                            name: "Driver's Seat",
                            notes: "Leather is ripped",
                            images: [
                                {
                                    photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                                    thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                                }, 
                                {
                                    photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                                    thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                                },
                                {
                                    photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                                    thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                                },
                            ],
                            damages: ['Scratch', 'Missing Piece']
                        },
                        {
                            name: "Passenger's Seat",
                            notes: "Leather is ripped",
                            images: [
                                {
                                    photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                                    thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                                }, 
                                {
                                    photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                                    thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                                },
                                {
                                    photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                                    thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                                },
                            ],
                            damages: ['Scratch', 'Missing Piece']
                        },
                ]
            },
            accessories: {
                found: ['S/D Card', 'Floor Mats', 'Charging Cable', 'Insurance'],
                extra: 'GPS System',
                images: [
                    {
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                    }, 
                    {
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                    },
                    {
                        photo: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png',
                        thumbnail: 'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_20_R8_G_WUAKBAFX5L7900212_1c8688cf-880c-4eed-acf6-d100f8f39eb1.png'   
                    },
                ]
            }
        })
        .then(function(response) {
            // console.log(response?.data)
        })
        .catch(function(error) {
            // console.log(error)
        })
    }
    
    //Whenever an input is changed, will call this function and set the corresponding state variable to the input to be used for logging in
    //Useful for any component with a form in it
    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
    
        this.setState({
          [name]: value,
          textbox_css: "",
          errors: <div />,
          error: false
        });
    }

    checkIfNameExists(object, name) {
        let found = false;

        object.map((image) => {
            if(image.Name == name)
            {
                found = true;
                return;
            }
        })

        return found;
    }

    fetchDamageInfo(previous_damages, damages) {
        let damagesRemaining = damages;
        let previousDamagesRemaining = previous_damages;
        let damageInfo = {};
        let newDamage = false;
        let clearedDamage = false;
        let Notes = false;
        let Images = false;

        damages.map((damage, index) => {
            damageInfo[damage.Name] = {"New Damages": [], "Existing Damages": [], "Cleared Damages": []};
            if(damage.Name in previous_damages) {
                damage.cr_part_damage_type.map((damage_type, index2) => {
                    if(damage_type.Name in previous_damages[damage.Name]) {
                        if(damage_type.Damaged) {
                            damageInfo[damage.Name]["Existing Damages"].push(damage_type.Name);
                        } else {
                            damageInfo[damage.Name]["Cleared Damages"].push(damage_type.Name)
                        }
                    } else {
                        damageInfo[damage.Name]["New Damages"].push(damage_type.Name);        
                    }
                });
            } else {
                damageInfo[damage.Name]["New Damages"].push(damage_type.Name);
            }

            if(damage.Notes) {
             Notes = true;
            }

            if(damage.images.length) {
             Images = true;
            }
        });

        Object.keys(damageInfo).forEach(function(damage) {
           if(damageInfo[damage]["New Damages"].length) {
             newDamage = true;
           }
           if(damageInfo[damage]["Cleared Damages"].length) {
            clearedDamage = false;
           }
        });

        return {damageInfo: damageInfo, newDamage: newDamage, clearedDamage: clearedDamage, Notes: Notes, Images: Images};
    }

    fetchCheckboxInfo(previous_accessories, accessories) {
        let accessoriesList = {};
        
        this.state.vehicle_info.accessory_options.map((accessory) => {
            let checkBox = "CLEAR";
            Object.keys(accessories).forEach(function(current_accessory) {
               if(accessories[current_accessory]["Name"] == accessory) {
                if(accessories[current_accessory]["Accessory_Damaged"]) {
                    checkBox = "DAMAGE";
                } else if(accessories[current_accessory]["Accessory_Found"]) {
                    checkBox = "NEW";
                }
               }
            });

            Object.keys(previous_accessories).forEach(function(previous_accessory) {
               if(previous_accessories[previous_accessory]["Name"] == accessory && previous_accessories[previous_accessory]["Accessory_Found"] && checkBox == "NEW") {
                    checkBox = "Existing";
               }
            });

            accessoriesList[accessory] = checkBox;
        });

        return accessoriesList;
    }
    
    render() {
        var accessory_list = "accessory_checkbox_info" in this.state ? this.state.accessory_checkbox_info : {};

        if("accessory_checkbox_info" in this.state) {
            accessory_list = Object.keys(this.state.accessory_checkbox_info).map(function(accessory) {
                return <>
                    {accessory}: {accessory_list[accessory]} <br />
                </>
            })   
        }

        return (
            <div>
                <div className = "bkg-white-dark">
                    <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                    <div className="sh-dashboard-container fixed-navbar-page fixed-alertbar-page" style={{height: "100%", padding: "10%"}}>
                        <a className = "button primary px-32 mr-8" onClick={this.dashboard}><span>Dashboard</span></a>
                        <a className = "button primary px-32 mr-8" onClick={this.createCR}><span>Create CR</span></a>
                        <a className = "button primary px-32 mr-8" onClick={this.storeCRNoExtra}><span>Store Only CR</span></a>
                        <a className = "button primary px-32 mr-8" onClick={this.storeCRExtraDetails}><span>Store CR + Details</span></a>
                        <a className = "button primary px-32 mr-8" onClick={this.storeEverything}><span>Store All details</span></a>
                    </div>
                </div>
                {
                    "report" in this.state ?
                        <div>
                            VIN: { this.state.report.vehicle.VIN} | Inspection Date: { this.state.report.Created_At }
                            <br />
                            <b>Vehicle Information:</b>
                            <br />
                            Vehicle { this.state.report.vehicle.Year} { this.state.report.vehicle.Make} { this.state.report.vehicle.Model} { this.state.report.vehicle.Trim}
                            <br />
                            VIN: { this.state.report.vehicle.VIN}
                            <br />
                            Exterior Color: { this.state.report.vehicle.Exterior_Exact_Color }
                            <br />
                            <br />
                            <b>Vehicle Information:</b>
                            <br />
                            Keys: { this.state.report.vehicle.Num_Keys }
                            <br />
                            Mileage: { this.state.report.vehicle.Odometer }
                            <br />
                            Fuel Level: { this.state.report.vehicle.Fuel_Level }
                            <br />
                            <br />
                            <b>Vehicle Damage:</b>
                            <br />
                            Exterior: 
                            { 
                                this.state.report.exterior_damages.map((damage) => {
                                    return (damage.Name + ", ")
                                })
                            }
                            <br />&nbsp;&nbsp;&nbsp;&nbsp;
                             { this.state.exterior_damages_info.newDamage ? "☑" : "☐"} New Damage
                            <br />&nbsp;&nbsp;&nbsp;&nbsp;
                             { this.state.exterior_damages_info.clearedDamage ? "☑" : "☐"} Cleared Damage
                            <br />
                            Interior:
                            { 
                                this.state.report.interior_damages.map((damage) => {
                                    return (damage.Name + ", ")
                                })
                            }
                            <br />&nbsp;&nbsp;&nbsp;&nbsp;
                             { this.state.interior_damages_info.newDamage ? "☑" : "☐"} New Damage
                            <br />&nbsp;&nbsp;&nbsp;&nbsp;
                             { this.state.interior_damages_info.clearedDamage ? "☑" : "☐"} Cleared Damage
                            <br />
                            <br />
                            <b>Report History:</b>
                            <br />
                            Page|Report By|Date of Last Report
                            <br />
                            {
                                this.state.previous_reports.map((report) => {
                                    return (
                                        <>
                                            { 'V' + (report.Type == 0 ? ', O' : '') + (report.Type == 1 ? ', I' : '') + (report.Exterior ? ', E' : '') + (report.Interior ? ', I' : '') + (report.Accessories ? ', A' : '')} | 
                                            { report.Reported_By } | 
                                            { moment(report.Report_Date).format("MMM DD, YYYY") }
                                            <br />
                                        </>
                                    );
                                })
                            }
                            <b>Vehicle In/Out Info:</b>
                            <br />
                            IN:  { this.state.report.Type == "0" ? "☑" : "☐"} | OUT:  { this.state.report.Type == "1" ? "☑" : "☐"}
                            <br />
                            Dates: { this.state.report.Type != null ?
                                        (moment(this.state.report.booking.Start_Date).format("MM") == moment(this.state.report.booking.End_Date).format("MM")) ?
                                            (moment(this.state.report.booking.Start_Date).format("MMM DD - ") + moment(this.state.report.booking.End_Date).format("DD, YYYY"))
                                        :
                                            (moment(this.state.report.booking.Start_Date).format("MMM DD - ") + moment(this.state.report.booking.End_Date).format("MMM DD, YYYY"))
                                    :
                                        "N/A"   
                                   }
                            <br />
                            Driver: { this.state.report.drivers_info ? this.state.report.drivers_info.Driver_Name : "" }
                            <br />
                            Location: {this.state.report.Location}
                            <br />
                            <br />
                            <b>Vehicle Image:</b>
                            <br />
                            Image URL: { this.state.report.vehicle.CR_Photos }
                            <br />
                            <br />
                            <b>Report Checklist:</b>
                            <br />
                            <u>In/Out</u>
                            <br />
                            Type: {
                                this.state.report.Type != null ? (this.state.report.Type == "0" ? "IN" : "OUT") : "N/A"
                            } 
                             { this.state.report.Type != null ? "☑" : "☐"}
                            <br />
                            Location of Vehicle
                             { this.state.report.Location ? "☑" : "☐"}
                            <br />
                            Driver's Info:
                             { this.state.report.drivers_info ? "☑" : "☐"}
                            <br />
                            Bill of Lading
                             { this.state.report.bill_lading ? "☑" : "☐"}
                            <br />
                            Vehicle Loan Agreement
                             { this.state.report.bill_lading ? "☑" : "☐"}
                            <br />
                            <u>Exterior</u>
                            <br />
                            Images of 4 Sides
                             { this.state.report.required_exterior_images.length == 4 ? "☑" : "☐"}
                            <br />
                            Damage
                             (
                                { this.state.exterior_damages_info.newDamage ? "DAMAGE | " : "" }
                                { this.state.exterior_damages_info.Notes ? "NOTES | " : "" }
                                { this.state.exterior_damages_info.Images ? "IMAGES" : "" }
                             )
                             { this.state.report.exterior_damages.length > 0 ? "☑" : "☐"}
                            <br />
                            <u>Interior</u>
                            <br />
                            Image of Dashboard
                             { this.checkIfNameExists(this.state.report.required_interior_images, "Dashboard Display") ? "☑" : "☐"}
                            <br />
                            Milage/Fuel Range
                             { this.state.report.Mileage ? "☑" : "☐"}
                            <br />
                            Image of trunk
                             { this.checkIfNameExists(this.state.report.required_interior_images, "Trunk Interior") ? "☑" : "☐"}
                             <br />
                            Image of Keys
                             { this.state.report.Key_Image ? "☑" : "☐"}
                            <br />
                            Damage
                             (
                                { this.state.interior_damages_info.newDamage ? "DAMAGE | " : "" }
                                { this.state.interior_damages_info.Notes ? "NOTES | " : "" }
                                { this.state.interior_damages_info.Images ? "IMAGES" : "" }
                             )
                             { this.state.report.interior_damages.length > 0 ? "☑" : "☐"}
                            <br />
                            <u>Accessories</u>
                            <br />
                            Accessories Verified
                             { this.state.report.accessories ? "☑" : "☐" }
                            <br />
                            Image of Accessories Added
                             { this.state.report.accessory_images.length > 0 ? "☑" : "☐" }
                            <br />
                            Notes Added
                             { this.state.report.Accessories_Notes ? "☑" : "☐" }
                            <br />
                            Damage
                            <br />
                            <u>Submit</u>
                            <br />
                            Waiver Agreement
                            <br />
                            <br />
                            <b>Waiver Agreement:</b>
                            <br />
                            {this.state.report.Driver_Signature } - {moment(this.state.report.Created_At).format("MMM DD, YYYY")}
                            <br />
                            <br />
                            <br />
                            <b><u>Exterior Report:</u></b>
                            <br />
                            <b>Exterior Damage:</b>
                            <br />
                            { 
                                this.state.report.exterior_damages.map((damage) => {
                                    return (damage.Name + ", ")
                                })
                            }
                            <br />
                            { this.state.report.Exterior_Properly_Inspected == "1" ? "☑" : "☐"} Dirty/Poor Visibility
                            <br />
                            <br />
                            <b>Exterior Images:</b>
                            <br />
                            { 
                                this.state.report.required_exterior_images.map((image) => {
                                    return (image.Name + ": " + image.Thumbnail + " | ")
                                })
                            }
                            <br />
                            <br />
                            <b>Exterior Damage Details:</b>
                            <br />
                            { 
                                this.state.report.exterior_damages.map((damage) => {
                                    return <>
                                        { damage.Name } <br />
                                        Notes: { damage.Notes } <br />
                                        {
                                            damage.images.map((image) => {
                                                return (image.Thumbnail + "| ");
                                            })
                                        }
                                    </>
                                })
                            }
                            <br />
                            <br />
                            <br />
                            <b><u>Interior Report:</u></b>
                            <br />
                            <b>Interior Damage:</b>
                            <br />
                            { 
                                this.state.report.exterior_damages.map((damage) => {
                                    return (damage.Name + ", ")
                                })
                            }
                            <br />
                            { this.state.report.Interior_Properly_Inspected == "1" ? "☑" : "☐"} Dirty/Poor Visibility
                            <br />
                            <br />
                            <b>Interior Images:</b>
                            <br />
                            { 
                                this.state.report.required_interior_images.map((image) => {
                                    return (image.Name + ": " + image.Thumbnail + " | ")
                                })
                            }
                            <br />
                            <br />
                            <b>Interior Damage Details:</b>
                            <br />
                            { 
                                this.state.report.interior_damages.map((damage) => {
                                    return <>
                                        { damage.Name } <br />
                                        Notes: { damage.Notes } <br />
                                        {
                                            damage.images.map((image) => {
                                                return (image.Thumbnail + "| ");
                                            })
                                        }
                                    </>
                                })
                            }
                            <br />
                            <br />
                            <br />
                            <b><u>Accessory Report:</u></b>
                            <br />
                            <b>Accessory List:</b>
                            <br />
                            { accessory_list }
                            <br />
                            <b>Accessory Notes:</b>
                            <br />
                            { this.state.report.Accessories_Notes }
                            <br />
                            <br />
                            <b>Accessory Images</b>
                            <br />
                            { 
                                this.state.report.accessory_images.map((image) => {
                                    return <>
                                        { image.Thumbnail } <br />
                                    </>
                                })
                            }
                            <br />
                        </div>
                    :
                        <div>
                            No report
                        </div>
                }
            </div>
        );
    }
}


const mapStateToProps = store => ({
})

export default withRouter(connect(mapStateToProps)(CRPage));